import { useContext } from 'react';
import Steps from './Steps';
import PropTypes from 'prop-types';
import {NavigationContext} from "../../context/NavigationContext";
import {Wrapper, Main, InputContainer} from 'shared/wizard/ToolContainer';
import {InternalServerError, HypotheekbondLogo} from 'shared/components';
import { Disclaimer } from 'shared/wizard';
import { Footer } from 'shared/containers';
import FinalFormNavigation from './FinalFormNavigation';
import { css } from '@emotion/react';

const View = ({ broken, handleSubmit, errors, submitting, children }) => {
  const { onResultPage } = useContext(NavigationContext);

  if (broken) {
    return (
      <InputContainer>
        <InternalServerError />
      </InputContainer>
    );
  }

  if (!onResultPage) {
    return (
      <InputContainer as="form" onSubmit={handleSubmit}>
        {children}
        <FinalFormNavigation
          handleSubmit={handleSubmit}
          errors={errors}
          loading={submitting}
        />
      </InputContainer>
    );
  }

  return children
}
const ToolContainer = ({ settings, ...props }) => (
  <Wrapper>
    <Steps />
    <Main css={css`margin-bottom: 16px`}>
      <View {...props} />
    </Main>
    <Footer>
      {settings.enableDisclaimer && <Disclaimer settings={settings} />}
      {settings.enableHypotheekbondLogo && <HypotheekbondLogo />}
    </Footer>
  </Wrapper>
);

ToolContainer.defaultProps = {
  children: PropTypes.node.isRequired,
};

export default ToolContainer;
